import { render } from "./AccountChangeNickname.vue?vue&type=template&id=5202e15e&ts=true"
import script from "./AccountChangeNickname.vue?vue&type=script&lang=ts"
export * from "./AccountChangeNickname.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__